// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__au5x6","rotation":"LoadingSpinner_rotation__CHHvr","blackSpinner":"LoadingSpinner_blackSpinner__IUKRJ"};